"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _host = require("../../host");
class HostServiceSA extends _host.HostService {
  constructor(params) {
    var _params$config, _params$config$devSet;
    super(params);
    this.openInNewTab = params === null || params === void 0 ? void 0 : (_params$config = params.config) === null || _params$config === void 0 ? void 0 : (_params$config$devSet = _params$config.devSettings) === null || _params$config$devSet === void 0 ? void 0 : _params$config$devSet.openDeepLinksNewTab;
  }
  addToCart(_ref) {
    let {
      handsetProductUrl
    } = _ref;
    setTimeout(() => {
      try {
        this.redirect({
          path: handsetProductUrl,
          target: this.openInNewTab ? '_blank' : '_self',
          origin: ''
        });
      } catch (error) {
        console.error('Unable to open product page');
      }
    }, 2);
  }
}
var _default = HostServiceSA;
exports.default = _default;